function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import _formatMuiErrorMessage from "@mui/utils/formatMuiErrorMessage";
import deepmerge from '@mui/utils/deepmerge';
import styleFunctionSx, { unstable_defaultSxConfig as defaultSxConfig } from '@mui/system/styleFunctionSx';
import systemCreateTheme from '@mui/system/createTheme';
import generateUtilityClass from '@mui/utils/generateUtilityClass';
import createMixins from "./createMixins.js";
import createPalette from "./createPalette.js";
import createTypography from "./createTypography.js";
import shadows from "./shadows.js";
import createTransitions from "./createTransitions.js";
import zIndex from "./zIndex.js";
import { stringifyTheme } from "./stringifyTheme.js";
function createThemeNoVars() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    var breakpointsInput = options.breakpoints, tmp = options.mixins, mixinsInput = tmp === void 0 ? {} : tmp, spacingInput = options.spacing, tmp1 = options.palette, paletteInput = tmp1 === void 0 ? {} : tmp1, tmp2 = options.transitions, transitionsInput = tmp2 === void 0 ? {} : tmp2, tmp3 = options.typography, typographyInput = tmp3 === void 0 ? {} : tmp3, shapeInput = options.shape, other = _object_without_properties(options, [
        "breakpoints",
        "mixins",
        "spacing",
        "palette",
        "transitions",
        "typography",
        "shape"
    ]);
    if (options.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
    // `generateThemeVars` is the closest identifier for checking that the `options` is a result of `createTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
    options.generateThemeVars === undefined) {
        throw new Error(process.env.NODE_ENV !== "production" ? 'MUI: `vars` is a private field used for CSS variables support.\n' + 'Please use another name or follow the [docs](https://mui.com/material-ui/customization/css-theme-variables/usage/) to enable the feature.' : _formatMuiErrorMessage(20));
    }
    var palette = createPalette(paletteInput);
    var systemTheme = systemCreateTheme(options);
    var muiTheme = deepmerge(systemTheme, {
        mixins: createMixins(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: shadows.slice(),
        typography: createTypography(palette, typographyInput),
        transitions: createTransitions(transitionsInput),
        zIndex: _object_spread({}, zIndex)
    });
    muiTheme = deepmerge(muiTheme, other);
    muiTheme = args.reduce(function(acc, argument) {
        return deepmerge(acc, argument);
    }, muiTheme);
    if (process.env.NODE_ENV !== 'production') {
        // TODO v6: Refactor to use globalStateClassesMapping from @mui/utils once `readOnly` state class is used in Rating component.
        var stateClasses = [
            'active',
            'checked',
            'completed',
            'disabled',
            'error',
            'expanded',
            'focused',
            'focusVisible',
            'required',
            'selected'
        ];
        var traverse = function(node, component) {
            var key;
            // eslint-disable-next-line guard-for-in
            for(key in node){
                var child = node[key];
                if (stateClasses.includes(key) && Object.keys(child).length > 0) {
                    if (process.env.NODE_ENV !== 'production') {
                        var stateClass = generateUtilityClass('', key);
                        console.error([
                            "MUI: The `".concat(component, "` component increases ") + "the CSS specificity of the `".concat(key, "` internal state."),
                            'You can not override it like this: ',
                            JSON.stringify(node, null, 2),
                            '',
                            "Instead, you need to use the '&.".concat(stateClass, "' syntax:"),
                            JSON.stringify({
                                root: _define_property({}, "&.".concat(stateClass), child)
                            }, null, 2),
                            '',
                            'https://mui.com/r/state-classes-guide'
                        ].join('\n'));
                    }
                    // Remove the style to prevent global conflicts.
                    node[key] = {};
                }
            }
        };
        Object.keys(muiTheme.components).forEach(function(component) {
            var styleOverrides = muiTheme.components[component].styleOverrides;
            if (styleOverrides && component.startsWith('Mui')) {
                traverse(styleOverrides, component);
            }
        });
    }
    muiTheme.unstable_sxConfig = _object_spread({}, defaultSxConfig, other === null || other === void 0 ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return styleFunctionSx({
            sx: props,
            theme: this
        });
    };
    muiTheme.toRuntimeSource = stringifyTheme; // for Pigment CSS integration
    return muiTheme;
}
var warnedOnce = false;
export function createMuiTheme() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    if (process.env.NODE_ENV !== 'production') {
        if (!warnedOnce) {
            warnedOnce = true;
            console.error([
                'MUI: the createMuiTheme function was renamed to createTheme.',
                '',
                "You should use `import { createTheme } from '@mui/material/styles'`"
            ].join('\n'));
        }
    }
    return createThemeNoVars.apply(void 0, _to_consumable_array(args));
}
export default createThemeNoVars;
